(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const init = () => {
    document.querySelectorAll('.pk-product-collector').forEach(product => {
      const gift = product.querySelector('.pk-product-gifts-below-media');
      const payment = product.querySelector('.product-form__buttons')?.closest('product-form');
      if (!gift || !payment || gift.dataset.mobilePlacementReady) return;
      gift.dataset.mobilePlacementReady = 'true';
      const anchor = document.createComment('karma-gifts-desktop-position');
      gift.before(anchor);
      const arrange = () => {
        if (mobile.matches) payment.after(gift);
        else anchor.after(gift);
      };
      arrange();
      mobile.addEventListener('change', arrange);
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
